import { render } from "./FeedSites.vue?vue&type=template&id=7902126d&scoped=true"
import script from "./FeedSites.vue?vue&type=script&lang=js"
export * from "./FeedSites.vue?vue&type=script&lang=js"

import "./FeedSites.vue?vue&type=style&index=0&id=7902126d&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7902126d"]])

export default __exports__